import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PortalShell } from '@/shared/patterns/AppShell';
import { salesNav, SALES_PORTAL_TITLE } from '@/domains/sales';
import { NewSaleButton } from '@/domains/sales/portal/components/NewSaleButton';
import { CustomerQuickSearch } from '@/domains/sales/quicksearch/CustomerQuickSearch';
import { requirePortal } from '@/app/entry/portalGuards';

export const Route = createFileRoute('/_backoffice/sales')({
    beforeLoad: ({ context }) => requirePortal(context.auth, 'sales'),
    component: () => (
        <PortalShell
            title={SALES_PORTAL_TITLE}
            nav={salesNav}
            actions={
                <>
                    <CustomerQuickSearch />
                    <NewSaleButton />
                </>
            }
        >
            <Outlet />
        </PortalShell>
    ),
});
